<template>
  <div class="wrapper  box_v">
    <!--头部-->
    <page-head title="黑名单" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
      <!-- <div slot class="box tab-wrapper">
        <div class="tab-btn" @click="$router.replace({name:'appointmentRecord'})">预约记录</div>
        <div class="tab-btn" @click="$router.replace({name:'appointmentService'})">服务项目</div>
        <div class="tab-btn active">黑名单</div>
      </div> -->
    </page-head>

    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="6">
              <FormItem label="姓名" prop="host">
                <Input v-model="name"/>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="身份证" prop="host">
                <Input v-model="idcardno"/>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <i-table
            :columns="settingColumn"
            :border="true"
            :loading="isLoading"
            :data="blacklist"
            stripe
            ref="table"
          >
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row, 'detail')" class="action">[修改]</span>
             <Poptip
                confirm
                title="确认删除?"
                placement="left"
                @on-ok="handleClickDetail(row, 'del')"
              >
                <span class="action">[删除]</span>
              </Poptip>
              <!-- <span class="action" @click="handleClickDetail(row, 'audit')">[审核]</span> -->
            </template>

          </i-table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <Modal  v-model="modal1" title="黑名单设置">
        <i-form ref="search" :model="query3">
          <row :gutter="80">
            <i-col span="12">
              <FormItem label="姓名">
                <Select
                  remote
                  :remote-method="getappointmentBlacklist"
                  :loading="isLoading2"
                  filterable
                  clearable
                  placeholder=""
                  v-model="query3.valIndex"
                  @on-change="onSelectChange"
                >
                  <Option
                    v-for="(item, index) in users"
                    :value="index"
                    :key="item.unionid"
                  >{{item.realName}}({{item.userName}})</Option>
                </Select>
              </FormItem>
              <!-- <form-item label="姓名" prop="name">
                <Input
                  v-model="query3.name"
                  clearable
                  placeholder="请输入"
                />
              </form-item> -->
            </i-col>
            <i-col span="12">
              <form-item label="身份证" prop="idcardno">
                <Input
                  v-model="query3.idcardno"
                  maxlength="18"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
              <i-col span="12">
                <FormItem label="手机号">
                  <Select
                    remote
                    :remote-method="getappointmentBlacklist1"
                    :loading="isLoading2"
                    filterable
                    clearable
                    placeholder=""
                    v-model="query3.valIndex"
                    @on-change="onSelectChange"
                  >
                    <Option
                      v-for="(item, index) in users"
                      :value="index"
                      :key="item.unionid"
                    >{{item.phoneNO}}</Option>
                  </Select>
                </FormItem>
                <!-- <form-item label="手机号" prop="phoneno">
                  <Input
                    maxlength="11"
                    v-model="query3.phoneno"
                    clearable
                    placeholder="请输入"
                  />
                </form-item> -->
              </i-col>
              <i-col span="12">
                <form-item label="备注信息" prop="remark">
                  <Input type="textarea"
                    v-model="query3.remark"
                    clearable
                    placeholder="请输入备注信息"
                  />
                </form-item>
              </i-col>
           </row>
        </i-form>
        <div slot="footer">
            <Button type="error" size="large" long  @click="surerevise">确认</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
  import pageHead from '../../components/head'
  import api from "../../api/index";
  const {
    saveblacklist,delblacklist,getappointmentBlacklist
  } = api;
  var that
  export default {
    name: 'appointmentService',
    components: {
      pageHead
    },
    data() {
      return {
        isLoading2: false,
        isLoading: false,
        xiugaiid:'',
        name:"",
        idcardno:"",
        phoneno:"",
        page: 1,
        rows:10,
        blacklist: [],
        isNoData: false,
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
            btnType: 'default',
          }, {
            name: '新增',
            type: 'add',
            loading: false,
            btnType: 'default',
          }
        ],
        settingColumn: [
          {
            title: "姓名",
            key: 'name'
          },
          {
            title: "身份证",
            key: "idcardno"
          },
          {
            title: "手机号",
            key: "phoneno"
          },
          {
            title: "备注",
            key: "remark"
          },
          {title: "操作",slot: "action"},
        ],
        total: 0,
        isTableLoading: false,
        selectAppointment: [],
        modal1:false,
        query3: {
          "name":'',
         	"phoneno": "",
         	"idcardno": "",
         	"remark": "",
          "valIndex":'',
          "unionid":''
        },
        users:[]
      }
    },
    methods: {
      onSelectChange(val) {
        console.log(val)
        if (val === undefined) {
          this.clearFormData();
        } else {
          let { realName, phoneNO, unionId } = this.users[val];
          this.query3.name = realName;
          this.query3.unionid = unionId;
          this.query3.phoneno = phoneNO;
          this.query3.valIndex =val;
          console.log(this.query3)

        }
      },
      clearFormData() {
        for (let key in this.query3) {
          this.query3[key] = "";
        }
        this.users = []
      },
      async getappointmentBlacklist(val) {
        if (val.trim() != "") {
          this.isLoading2 = true;
          try {
            let res = await this.$post(getappointmentBlacklist, {
              deptId: this.$route.query.id,
              realName: val
            });
            this.users = res.rows;
          }finally{
            this.isLoading2 = false
          }
        }else{
          this.users = []
        }
      },
      async getappointmentBlacklist1(val) {
        if (val.trim() != "") {
          this.isLoading2 = true;
          try {
            let res = await this.$post(getappointmentBlacklist, {
              deptId: this.$route.query.id,
              phoneNO: val
            });
            this.users = res.rows;
          }finally{
            this.isLoading2 = false
          }
        }else{
          this.users = []
        }
      },
      dorefresh(){
        this.page = 1
        this.name='';
        this.phoneno='';
        this.idcardno='';
        this.getBlacklist()
      },
      async handleClickDetail(item, type) {
        console.log(item, type);
        if (type == "detail") {
          this.query3={
            "name":item.name,
           	"phoneno":item.phoneno,
           	"idcardno":item.yuanidcardno,
           	"remark":item.remark,
            "unionid":item.unionid,
            "valIndex":0
          }
          let res = await this.$post(getappointmentBlacklist, {
            deptId: this.$route.query.id,
            phoneNO: item.phoneno
          });
          this.users = res.rows;
          this.xiugaiid=item.id
          this.modal1=true
        } else if (type == "del") {
           this.handleDelete(item.id);
        }
      },
      async handleDelete(id) {
        let url=delblacklist+"?id="+id
        console.log(url)
        console.log(id)
        let res = await this.$get(url);
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.dorefresh()
        }
      },
      initblackList() {
        this.page = 1
        this.getBlacklist()
      },
      getBlacklist() {
        let {page, rows,name,idcardno} = this
        this.isTableLoading = true
        this.$get(this.urlobj.jczlAppointmentBlacklist, {
          page: page,
          rows: rows,
          uid:sessionStorage["uid"],
          name:name,
          idcardno:idcardno,
        }).then(res => {
          console.log(res)
          this.isTableLoading = false
          if (!res.total) this.isNoData = true
          this.total = res.total
          for(let i=0;i<res.rows.length;i++){
            if(res.rows[i].idcardno){
              res.rows[i].yuanidcardno=res.rows[i].idcardno
              res.rows[i].idcardno=res.rows[i].idcardno.slice(0,14)+"****"
            }
          }
          this.blacklist = res.rows
        })
      },
      async surerevise () {
         if(!this.query3.name){
           this.$Message.success("请输入姓名");
           return ;
         }
         if(!this.query3.idcardno){
           this.$Message.success("请输入身份证号");
           return ;
         }
         console.log(this.query3.idcardno.length)
         if(this.query3.idcardno.length!=18){
           this.$Message.success("请输入正确的身份证号");
           return ;
         }
         if(!this.query3.phoneno){
           this.$Message.success("");
           return ;
         }
         if(this.query3.phoneno.length!=11){
           this.$Message.success("请输入正确的手机号");
           return ;
         }
         if(!this.query3.remark){
           this.$Message.success("请输入备注信息");
           return ;
         }

         console.log(this.query3)
         let res = await this.$post(saveblacklist, {
           uid:sessionStorage["uid"],
           id:this.xiugaiid,
           ...this.query3,
         });
         if (res.isSucceed) {
           this.$Message.success("保存成功");
            this.dorefresh()
           this.modal1=false;
         }
      },
      handleBtn(type) {
        if (type == 'add') {
          this.query3={
            "name":'',
            "phoneno": "",
            "idcardno": "",
            "remark": "",
            "valIndex":'',
            "unionid":''
          }
          this.xiugaiid=''
          this.modal1=true
        } else if (type == 'search') {
          this.initblackList()
        } else if (type == 'init') {
            this.dorefresh()
        }
      },

      pageChange(val) {
        this.page = val;
        this.getBlacklist();
      },


      clickRow(value) {

      }
    },
    mounted() {
      that = this
      this.page = 1
      this.getBlacklist()
    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  .wrapper {
    height: 100%;
  }

  .add-btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }

  .nodata-card {
    margin: 0 20px 20px;
    align-items: center;
    justify-content: center;
    img {
      height: 280px;
      width: 390px;
    }
    .text {
      font-size: 15px;
      color: #ff7744;
      line-height: 1;
      padding: 25px 0 30px;
      letter-spacing: 10px;
      text-align: center;
    }
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
